import {
  Alert,
  Box,
  Button,
  Checkbox,
  Divider,
  List,
  ListItem,
  Popover,
  TextField,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import InputAdornment from '@mui/material/InputAdornment';
import { CustomPopoverCss } from './CustomPopoverCss';
import {
  addSiteInDashboardText,
  customPopoverTexts,
  keywordResearchKdSubOptions,
  paths
} from './config/TextMessage';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBackLinkFilters,
  setCompetitorAnalysisFilters,
  setCompetitorAnalysisSection,
  setKeywordListsFilters,
  setKeywordOverviewFilters,
  setKeywordOverviewSection
} from 'src/redux/keywordResearch';
import { RootState } from 'src/redux/store';
import { keywordResearchDashBoardCss } from 'src/content/keywordResearch/keywordResearchCSS';
import { useLocation } from 'react-router';

export const CustomDropdown = ({
  labelText,
  options = [],
  showFields = false,
  showCheckBox = false,
  moreFilters = false,
  showColorBox = false,
  isCompetitorAnalysis = false,
  isKeywordList = false,
  isBackLinks = false,
  isSpamScore = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [fromValue, setFromValue] = useState(null);
  const [fromKrValue, setFromKrValue] = useState(null);
  const [fromWcValue, setFromWcValue] = useState(null);
  const [toValue, setToValue] = useState(null);
  const [toKrValue, setToKrValue] = useState(null);
  const [toWcValue, setToWcValue] = useState(null);
  const [error, setError] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [applyFilterValues, setApplyFilterValues] = useState({
    'Search Volume': '',
    'KD %': '',
    Status: '',
    Intent: [],
    Position: '',
    'Back links': '',
    'Your Position': ''
  });
  const isLimitExhausted =
    useSelector((state: RootState) => state.keywordResearch.isLimitExhausted) ??
    null;
  const isDiyOrLimit = isLimitExhausted;
  //const isDiyOrLimit = isDIY || isLimitExhausted;
  const keywordOverviewFilters: any =
    useSelector(
      (state: RootState) => state.keywordResearch.keywordOverviewFilters
    ) ?? {};
  const competitorAnalysisFilters: any =
    useSelector(
      (state: RootState) => state.keywordResearch.competitorAnalysisFilters
    ) ?? {};
  const bulkKeywordDifficultyReduxData =
    useSelector(
      (state: RootState) => state.keywordResearch.bulkKeywordDifficultyReduxData
    ) ?? null;
  const competitorDetailsReduxData =
    useSelector(
      (state: RootState) => state.keywordResearch.competitorDetailsReduxData
    ) ?? null;
  const keywordOverviewSection =
    useSelector(
      (state: RootState) => state.keywordResearch.keywordOverviewSection
    ) ?? 0;
  const competitorAnalysisSection =
    useSelector(
      (state: RootState) => state.keywordResearch.competitorAnalysisSection
    ) ?? 0;
  const keywordListsFilters: any =
    useSelector(
      (state: RootState) => state.keywordResearch.keywordListsFilters
    ) ?? {};
  const keywordLists: any =
    useSelector((state: RootState) => state.keywordResearch.keywordLists) ?? [];
  const keywordListsSection =
    useSelector(
      (state: RootState) => state.keywordResearch.keywordListsSection
    ) ?? 0;
  const keywordListsDetails: any =
    useSelector(
      (state: RootState) => state.keywordResearch.keywordListsDetails
    ) ?? [];
  const backLinkData: any =
    useSelector((state: RootState) => state.keywordResearch.backLinkData) ?? [];
  const backLinkFilters: any =
    useSelector((state: RootState) => state.keywordResearch.backLinkFilters) ??
    [];
  const location = useLocation();
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const colorPalette = [
    'rgba(50, 213, 131, 1)',
    'rgba(254, 223, 137, 1)',
    'rgba(253, 176, 34, 1)',
    'rgba(251, 101, 20, 1)',
    'var(--color-error-bright)'
  ];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (!open) {
      setToValue(null);
      setFromValue(null);
    }
  }, [open]);

  // Keyword research
  useEffect(() => {
    if (
      Object.keys(keywordOverviewFilters)?.length > 0 &&
      location?.pathname === paths?.keywordOverview &&
      keywordOverviewSection !== 0
    ) {
      setApplyFilterValues({
        'Search Volume': keywordOverviewFilters?.searchVolume || '',
        'KD %': keywordOverviewFilters?.kd || '',
        Status: keywordOverviewFilters?.status || '',
        Position: keywordOverviewFilters?.position || '',
        'Back links': '',
        Intent:
          keywordOverviewFilters?.intent?.length > 0
            ? keywordOverviewFilters?.intent
            : [],
        'Your Position': ''
      });
    }
  }, [keywordOverviewFilters]);

  useEffect(() => {
    if (
      Object.keys(keywordListsFilters)?.length > 0 &&
      location?.pathname === paths?.keywordsLists
    ) {
      setApplyFilterValues({
        'Search Volume': keywordListsFilters?.searchVolume || '',
        'KD %': keywordListsFilters?.kd || '',
        Status: keywordListsFilters?.status || '',
        Position: keywordListsFilters?.position || '',
        'Back links': '',
        Intent:
          keywordListsFilters?.intent?.length > 0
            ? keywordListsFilters?.intent
            : [],
        'Your Position': ''
      });
    }
  }, [keywordListsFilters]);

  useEffect(() => {
    if (
      Object.keys(backLinkFilters)?.length > 0 &&
      location?.pathname === paths?.backlinkPage &&
      !isSpamScore
    ) {
      setApplyFilterValues({
        'Search Volume': backLinkFilters?.searchVolume || '',
        'KD %': backLinkFilters?.kd || '',
        Status: backLinkFilters?.status || '',
        Position: backLinkFilters?.position || '',
        'Back links': '',
        Intent:
          backLinkFilters?.intent?.length > 0 ? backLinkFilters?.intent : [],
        'Your Position': ''
      });
    }
  }, [backLinkFilters]);

  useEffect(() => {
    if (
      Object.keys(backLinkFilters)?.length > 0 &&
      location?.pathname === paths?.backlinkPage &&
      isSpamScore
    ) {
      setApplyFilterValues({
        'Search Volume': backLinkFilters?.searchVolume || '',
        'KD %': backLinkFilters?.kd || '',
        Status: backLinkFilters?.status || '',
        Position: backLinkFilters?.spamScore || '',
        'Back links': '',
        Intent:
          backLinkFilters?.intent?.length > 0 ? backLinkFilters?.intent : [],
        'Your Position': ''
      });
    }
  }, [backLinkFilters]);

  useEffect(() => {
    const values = [toKrValue, fromKrValue, toWcValue, fromWcValue];
    const allValuesAreEmpty = values?.every(
      (value) => value === null || value === ''
    );

    if (allValuesAreEmpty) {
      setFilterCount(0);
    }
  }, [toKrValue, fromKrValue, toWcValue, fromWcValue]);

  // Competitor Analysis Filters
  useEffect(() => {
    if (
      Object.keys(competitorAnalysisFilters)?.length > 0 &&
      location?.pathname === paths?.competitorAnalysis &&
      competitorAnalysisSection !== 0
    ) {
      setApplyFilterValues({
        Status: competitorAnalysisFilters?.status || '',
        Position: competitorAnalysisFilters?.position || '',
        'Back links': competitorAnalysisFilters?.backLinks || '',
        Intent:
          competitorAnalysisFilters?.intent?.length > 0
            ? competitorAnalysisFilters?.intent
            : [],
        'Search Volume': competitorAnalysisFilters?.searchVolume || '',
        'KD %': competitorAnalysisFilters?.kd || '',
        'Your Position': competitorAnalysisFilters?.yourPosition || ''
      });
    }
  }, [competitorAnalysisFilters]);

  useEffect(() => {
    if (
      keywordOverviewFilters &&
      location?.pathname === paths?.keywordOverview &&
      keywordOverviewSection !== 0
    ) {
      switch (labelText) {
        case 'Search Volume':
          setSelectedValue(keywordOverviewFilters?.searchVolume || '');
          break;
        case 'KD %':
          setSelectedValue(keywordOverviewFilters?.kd || '');
          break;
        case 'Position':
          setSelectedValue(keywordOverviewFilters?.position || '');
          break;
        case 'Intent':
          setSelectedItems(
            keywordOverviewFilters?.intent?.length > 0
              ? keywordOverviewFilters?.intent
              : []
          );
          break;
        case 'More Filters':
          const [krFrom, krTo] = (
            keywordOverviewFilters?.keywordGoldenRation || ''
          ).split('-');
          const [wcFrom, wcTo] = (
            keywordOverviewFilters?.wordCount || ''
          ).split('-');
          if (
            keywordOverviewFilters?.keywordGoldenRation &&
            keywordOverviewFilters?.wordCount
          ) {
            setFilterCount(2);
          } else if (
            keywordOverviewFilters?.keywordGoldenRation ||
            keywordOverviewFilters?.wordCount
          ) {
            setFilterCount(1);
          }
          setFromKrValue(krFrom || '');
          setToKrValue(krTo || '');
          setFromWcValue(wcFrom || '');
          setToWcValue(wcTo || '');
          break;
        default:
          break;
      }
    }
  }, [labelText, bulkKeywordDifficultyReduxData]);

  useEffect(() => {
    if (keywordListsFilters && location?.pathname === paths?.keywordsLists) {
      switch (labelText) {
        case 'Search Volume':
          setSelectedValue(keywordListsFilters?.searchVolume || '');
          break;
        case 'KD %':
          setSelectedValue(keywordListsFilters?.kd || '');
          break;
        case 'Position':
          setSelectedValue(keywordListsFilters?.position || '');
          break;
        case 'Intent':
          setSelectedItems(
            keywordListsFilters?.intent?.length > 0
              ? keywordListsFilters?.intent
              : []
          );
          break;
        case 'More Filters':
          const [krFrom, krTo] = (
            keywordListsFilters?.keywordGoldenRation || ''
          ).split('-');
          const [wcFrom, wcTo] = (keywordListsFilters?.wordCount || '').split(
            '-'
          );
          if (
            keywordListsFilters?.keywordGoldenRation &&
            keywordListsFilters?.wordCount
          ) {
            setFilterCount(2);
          } else if (
            keywordListsFilters?.keywordGoldenRation ||
            keywordListsFilters?.wordCount
          ) {
            setFilterCount(1);
          }
          setFromKrValue(krFrom || '');
          setToKrValue(krTo || '');
          setFromWcValue(wcFrom || '');
          setToWcValue(wcTo || '');
          break;
        default:
          break;
      }
    }
  }, [labelText, keywordLists, keywordListsDetails]);

  useEffect(() => {
    if (
      backLinkFilters &&
      location?.pathname === paths?.backlinkPage &&
      !isSpamScore
    ) {
      switch (labelText) {
        case 'Search Volume':
          setSelectedValue(backLinkFilters?.searchVolume || '');
          break;
        case 'KD %':
          setSelectedValue(backLinkFilters?.kd || '');
          break;
        case 'Position':
          setSelectedValue(backLinkFilters?.position || '');
          break;
        case 'Intent':
          setSelectedItems(
            backLinkFilters?.intent?.length > 0 ? backLinkFilters?.intent : []
          );
          break;
        case 'More Filters':
          const [krFrom, krTo] = (
            backLinkFilters?.keywordGoldenRation || ''
          ).split('-');
          const [wcFrom, wcTo] = (backLinkFilters?.wordCount || '').split('-');
          if (
            backLinkFilters?.keywordGoldenRation &&
            backLinkFilters?.wordCount
          ) {
            setFilterCount(2);
          } else if (
            backLinkFilters?.keywordGoldenRation ||
            backLinkFilters?.wordCount
          ) {
            setFilterCount(1);
          }
          setFromKrValue(krFrom || '');
          setToKrValue(krTo || '');
          setFromWcValue(wcFrom || '');
          setToWcValue(wcTo || '');
          break;
        default:
          break;
      }
    }
  }, [labelText, backLinkData]);

  useEffect(() => {
    if (
      backLinkFilters &&
      location?.pathname === paths?.backlinkPage &&
      isSpamScore
    ) {
      switch (labelText) {
        case 'Search Volume':
          setSelectedValue(backLinkFilters?.searchVolume || '');
          break;
        case 'KD %':
          setSelectedValue(backLinkFilters?.kd || '');
          break;
        case 'Position':
          setSelectedValue(backLinkFilters?.spamScore || '');
          break;
        case 'Intent':
          setSelectedItems(
            backLinkFilters?.intent?.length > 0 ? backLinkFilters?.intent : []
          );
          break;
        case 'More Filters':
          const [krFrom, krTo] = (
            backLinkFilters?.keywordGoldenRation || ''
          ).split('-');
          const [wcFrom, wcTo] = (backLinkFilters?.wordCount || '').split('-');
          if (
            backLinkFilters?.keywordGoldenRation &&
            backLinkFilters?.wordCount
          ) {
            setFilterCount(2);
          } else if (
            backLinkFilters?.keywordGoldenRation ||
            backLinkFilters?.wordCount
          ) {
            setFilterCount(1);
          }
          setFromKrValue(krFrom || '');
          setToKrValue(krTo || '');
          setFromWcValue(wcFrom || '');
          setToWcValue(wcTo || '');
          break;
        default:
          break;
      }
    }
  }, [labelText, backLinkData]);

  useEffect(() => {
    if (
      competitorAnalysisFilters &&
      location?.pathname === paths?.competitorAnalysis &&
      competitorAnalysisSection !== 0
    ) {
      switch (labelText) {
        case 'Search Volume':
          setSelectedValue(competitorAnalysisFilters?.searchVolume || '');
          break;
        case 'Position':
          setSelectedValue(competitorAnalysisFilters?.position || '');
          break;
        case 'Your Position':
          setSelectedValue(competitorAnalysisFilters?.yourPosition || '');
          break;
        case 'Status':
          if (isCompetitorAnalysis) {
            setSelectedValue(competitorAnalysisFilters?.status || '');
          }
          break;
        case 'Back links':
          setSelectedValue(competitorAnalysisFilters?.backLinks || '');
          break;
        case 'Intent':
          if (isCompetitorAnalysis) {
            setSelectedItems(competitorAnalysisFilters?.intent || []);
          }
          break;
        case 'KD %':
          setSelectedValue(competitorAnalysisFilters?.kd || '');
          break;
        default:
          break;
      }
    }
  }, [labelText, competitorDetailsReduxData]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => {
    if (showCheckBox) {
      const currentIndex = selectedItems?.indexOf(value);
      const newChecked = [...selectedItems];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setSelectedItems(newChecked);
    } else {
      setSelectedValue(value);
      setToValue(null);
      setFromValue(null);
      //handleClose();
    }
  };

  const handleVerify = () => {
    if (
      fromValue &&
      toValue &&
      !isNaN(fromValue) &&
      !isNaN(toValue) &&
      Number(toValue) <= Number(fromValue)
    ) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 2000);
      return;
    } else if (
      // (fromKrValue && toKrValue && Number(toKrValue) < Number(fromKrValue)) ||
      fromWcValue &&
      toWcValue &&
      Number(toWcValue) <= Number(fromWcValue)
    ) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 2000);
      return;
    }
    let newSelectedValue = selectedValue;
    let newFilterCount = filterCount;

    if (
      fromValue &&
      toValue &&
      !isNaN(fromValue) &&
      !isNaN(toValue) &&
      Number(toValue) > Number(fromValue)
    ) {
      newSelectedValue = `${fromValue}-${toValue}`;
      setSelectedValue(newSelectedValue);
    } else if (
      (fromKrValue && toKrValue && Number(toKrValue) > Number(fromKrValue)) ||
      (fromWcValue && toWcValue && Number(toWcValue) > Number(fromWcValue))
    ) {
      if ((toKrValue && !toWcValue) || (!toKrValue && toWcValue)) {
        newFilterCount = 1;
      } else if (toKrValue && toWcValue) {
        newFilterCount = 2;
      }
      setFilterCount(newFilterCount);
    }
    handleApply(newSelectedValue);
  };
  const handleApply = async (newSelectedValue) => {
    switch (labelText) {
      case 'Search Volume':
        if (
          newSelectedValue ||
          (fromValue &&
            toValue &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            Number(toValue) > Number(fromValue))
        ) {
          if (isCompetitorAnalysis) {
            dispatch(
              setCompetitorAnalysisFilters({
                ...competitorAnalysisFilters,
                searchVolume: newSelectedValue
              })
            );
          } else {
            dispatch(
              setKeywordOverviewFilters({
                ...keywordOverviewFilters,
                searchVolume: newSelectedValue
              })
            );
            dispatch(
              setKeywordListsFilters({
                ...keywordListsFilters,
                searchVolume: newSelectedValue
              })
            );
          }
        }
        break;
      case 'KD %':
        if (
          newSelectedValue ||
          (fromValue &&
            toValue &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            Number(toValue) > Number(fromValue))
        ) {
          if (isCompetitorAnalysis) {
            dispatch(
              setCompetitorAnalysisFilters({
                ...competitorAnalysisFilters,
                kd: newSelectedValue
              })
            );
          } else if (isKeywordList) {
            dispatch(
              setKeywordListsFilters({
                ...keywordListsFilters,
                kd: newSelectedValue
              })
            );
          } else {
            dispatch(
              setKeywordOverviewFilters({
                ...keywordOverviewFilters,
                kd: newSelectedValue
              })
            );
          }
        }
        break;
      case 'Status':
        if (selectedValue && isCompetitorAnalysis) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              status: selectedValue
            })
          );
        } else if (selectedValue && isKeywordList) {
          dispatch(
            setKeywordListsFilters({
              ...keywordListsFilters,
              status: selectedValue
            })
          );
        } else if (selectedValue) {
          dispatch(
            setKeywordOverviewFilters({
              ...keywordOverviewFilters,
              status: selectedValue
            })
          );
        }
        break;
      case 'Intent':
        if (isCompetitorAnalysis) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              intent: selectedItems
            })
          );
        } else if (isKeywordList) {
          dispatch(
            setKeywordListsFilters({
              ...keywordListsFilters,
              intent: selectedItems
            })
          );
        } else {
          dispatch(
            setKeywordOverviewFilters({
              ...keywordOverviewFilters,
              intent: selectedItems
            })
          );
        }
        break;
      case 'More Filters':
        dispatch(
          setKeywordOverviewFilters({
            ...keywordOverviewFilters,
            keywordGoldenRation:
              fromKrValue &&
              toKrValue &&
              !isNaN(fromKrValue) &&
              !isNaN(toKrValue) &&
              Number(toKrValue) > Number(fromKrValue)
                ? `${fromKrValue}-${toKrValue}`
                : null,
            wordCount:
              fromWcValue &&
              toWcValue &&
              !isNaN(fromWcValue) &&
              !isNaN(toWcValue) &&
              Number(toWcValue) > Number(fromWcValue)
                ? `${fromWcValue}-${toWcValue}`
                : null
          })
        );
        dispatch(
          setKeywordListsFilters({
            ...keywordListsFilters,
            keywordGoldenRation:
              fromKrValue &&
              toKrValue &&
              !isNaN(fromKrValue) &&
              !isNaN(toKrValue) &&
              Number(toKrValue) > Number(fromKrValue)
                ? `${fromKrValue}-${toKrValue}`
                : null,
            wordCount:
              fromWcValue &&
              toWcValue &&
              !isNaN(fromWcValue) &&
              !isNaN(toWcValue) &&
              Number(toWcValue) > Number(fromWcValue)
                ? `${fromWcValue}-${toWcValue}`
                : null
          })
        );
        break;
      case 'Position':
        if (
          newSelectedValue ||
          (fromValue &&
            toValue &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            Number(toValue) > Number(fromValue))
        ) {
          if (isCompetitorAnalysis) {
            dispatch(
              setCompetitorAnalysisFilters({
                ...competitorAnalysisFilters,
                position: newSelectedValue
              })
            );
          } else if (isKeywordList) {
            dispatch(
              setKeywordListsFilters({
                ...keywordListsFilters,
                position: newSelectedValue
              })
            );
          } else if (isBackLinks && !isSpamScore) {
            dispatch(
              setBackLinkFilters({
                ...backLinkFilters,
                position: newSelectedValue
              })
            );
          } else if (isBackLinks && isSpamScore) {
            dispatch(
              setBackLinkFilters({
                ...backLinkFilters,
                spamScore: newSelectedValue
              })
            );
          } else {
            dispatch(
              setKeywordOverviewFilters({
                ...keywordOverviewFilters,
                position: newSelectedValue
              })
            );
          }
        }
        break;
      case 'Your Position':
        if (
          newSelectedValue ||
          (fromValue &&
            toValue &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            Number(toValue) > Number(fromValue))
        ) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              yourPosition: newSelectedValue
            })
          );
        }
        break;
      case 'Traffic':
        if (
          newSelectedValue ||
          (fromValue &&
            toValue &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            Number(toValue) > Number(fromValue))
        ) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              traffic: newSelectedValue
            })
          );
        }
        break;
      case 'Back links':
        if (
          newSelectedValue ||
          (fromValue &&
            toValue &&
            !isNaN(fromValue) &&
            !isNaN(toValue) &&
            Number(toValue) > Number(fromValue))
        ) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              backLinks: newSelectedValue
            })
          );
        }
        break;
      default:
        break;
    }
    handleClose();
    if (location?.pathname == paths?.keywordOverview) {
      if (keywordOverviewSection === 3) {
        dispatch(setKeywordOverviewSection(4));
      } else if (keywordOverviewSection === 4) {
        dispatch(setKeywordOverviewSection(4));
      } else {
        dispatch(setKeywordOverviewSection(1));
      }
    } else if (location?.pathname == paths?.competitorAnalysis) {
      if (competitorAnalysisSection === 3) {
        dispatch(setCompetitorAnalysisSection(4));
      } else if (competitorAnalysisSection === 4) {
        dispatch(setCompetitorAnalysisSection(4));
      } else {
        dispatch(setCompetitorAnalysisSection(1));
      }
    }
  };
  const handleCancel = () => {
    if (showCheckBox) {
      setSelectedItems([]);
    }
    switch (labelText) {
      case 'Search Volume':
        if (isCompetitorAnalysis) {
          setSelectedValue('');
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              searchVolume: null
            })
          );
        } else {
          setSelectedValue('');
          dispatch(
            setKeywordOverviewFilters({
              ...keywordOverviewFilters,
              searchVolume: null
            })
          );
          dispatch(
            setKeywordListsFilters({
              ...keywordListsFilters,
              searchVolume: null
            })
          );
        }
        break;
      case 'KD %':
        if (isCompetitorAnalysis) {
          setSelectedValue('');
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              kd: null
            })
          );
        } else if (isKeywordList) {
          setSelectedValue('');
          dispatch(
            setKeywordListsFilters({
              ...keywordListsFilters,
              kd: null
            })
          );
        } else {
          setSelectedValue('');
          dispatch(
            setKeywordOverviewFilters({
              ...keywordOverviewFilters,
              kd: null
            })
          );
        }
        break;
      case 'Status':
        if (isCompetitorAnalysis) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              status: null
            })
          );
          setSelectedValue('');
        } else if (isKeywordList) {
          dispatch(
            setKeywordListsFilters({
              status: null
            })
          );
          setSelectedValue('');
        } else {
          dispatch(
            setKeywordOverviewFilters({
              status: null
            })
          );
          setSelectedValue('');
        }
        break;
      case 'Intent':
        setSelectedValue('');
        if (isCompetitorAnalysis) {
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              intent: null
            })
          );
        } else if (isKeywordList) {
          dispatch(
            setKeywordListsFilters({
              ...keywordListsFilters,
              intent: null
            })
          );
        } else {
          dispatch(
            setKeywordOverviewFilters({
              ...keywordOverviewFilters,
              intent: null
            })
          );
        }
        break;
      case 'More Filters':
        setSelectedValue('');
        dispatch(
          setKeywordOverviewFilters({
            ...keywordOverviewFilters,
            keywordGoldenRation: null,
            wordCount: null
          })
        );
        dispatch(
          setKeywordListsFilters({
            ...keywordListsFilters,
            keywordGoldenRation: null,
            wordCount: null
          })
        );
        break;
      case 'Position':
        setSelectedValue('');
        if (isCompetitorAnalysis) {
          setSelectedValue('');
          dispatch(
            setCompetitorAnalysisFilters({
              ...competitorAnalysisFilters,
              position: null
            })
          );
        } else if (isKeywordList) {
          dispatch(
            setKeywordListsFilters({
              ...keywordListsFilters,
              position: null
            })
          );
        } else if (isBackLinks && !isSpamScore) {
          dispatch(
            setBackLinkFilters({
              ...backLinkFilters,
              position: null
            })
          );
        } else if (isBackLinks && isSpamScore) {
          dispatch(
            setBackLinkFilters({
              ...backLinkFilters,
              spamScore: null
            })
          );
        } else {
          dispatch(
            setKeywordOverviewFilters({
              ...keywordOverviewFilters,
              position: null
            })
          );
        }

        break;
      case 'Your Position':
        setSelectedValue('');
        dispatch(
          setCompetitorAnalysisFilters({
            ...competitorAnalysisFilters,
            yourPosition: null
          })
        );

        break;
      case 'Traffic':
        setSelectedValue('');
        dispatch(
          setCompetitorAnalysisFilters({
            ...competitorAnalysisFilters,
            traffic: null
          })
        );

        break;
      case 'Back links':
        setSelectedValue('');
        dispatch(
          setCompetitorAnalysisFilters({
            ...competitorAnalysisFilters,
            backLinks: null
          })
        );
        break;
      default:
        break;
    }
    handleClose();
  };

  const getChipStyles = (label) => {
    switch (label?.toLowerCase()) {
      case 'commercial':
        return {
          backgroundColor: 'var(--color-success-bg)',
          color: 'rgba(26, 146, 123, 1)',
          ...CustomPopoverCss?.intentInputSx
        };
      case 'informational':
        return {
          backgroundColor: 'rgba(241, 252, 187, 1)',
          color: 'rgba(76, 89, 9, 1)',
          ...CustomPopoverCss?.intentInputSx
        };
      case 'navigational':
        return {
          backgroundColor: 'rgba(247, 223, 255, 1)',
          color: 'rgba(116, 19, 149, 1)',
          ...CustomPopoverCss?.intentInputSx
        };
      case 'transactional':
        return {
          backgroundColor: 'rgba(212, 244, 251, 1)',
          color: 'rgba(17, 105, 124, 1)',
          ...CustomPopoverCss?.intentInputSx
        };
      // Add more cases for other chip styles
      default:
        return { backgroundColor: '', color: '' }; // Default styles
    }
  };

  const handleClearFilters = () => {
    setFilterCount(0);
    setFromKrValue('');
    setToKrValue('');
    setFromWcValue('');
    setToWcValue('');
    dispatch(
      setKeywordOverviewFilters({
        ...keywordOverviewFilters,
        keywordGoldenRation: null,
        wordCount: null
      })
    );
    dispatch(
      setKeywordListsFilters({
        ...keywordListsFilters,
        keywordGoldenRation: null,
        wordCount: null
      })
    );
    dispatch(
      setBackLinkFilters({
        ...backLinkFilters,
        keywordGoldenRation: null,
        wordCount: null
      })
    );
    handleClose();
  };

  // Updated Keyword label name after added
  const updatedKeywordFilterLabel = (filterLabel: any) => {
    if (
      filterLabel === 'Search Volume' &&
      isKeywordList &&
      keywordListsSection == 0
    ) {
      return 'Total Volume';
    }
    if (filterLabel === 'KD %' && isKeywordList && keywordListsSection == 0) {
      return 'Avg. KD %';
    }
    if (filterLabel === 'Intent') {
      return 'Search Intent';
    }
    if (isBackLinks && filterLabel === 'Position' && !isSpamScore) {
      return 'DA';
    }
    if (isBackLinks && filterLabel === 'Position' && isSpamScore) {
      return 'Spam Score';
    }
    return filterLabel;
  };
  return (
    <Box>
      <TextField
        disabled={isDiyOrLimit}
        aria-describedby="simple-popover"
        variant="outlined"
        fullWidth
        value={(!showCheckBox && applyFilterValues[labelText]) || ''}
        onClick={handleClick}
        label={`${updatedKeywordFilterLabel(labelText)}`}
        sx={{
          ...keywordResearchDashBoardCss?.removeBorderEffectForTextField,
          ...CustomPopoverCss?.mainTextFieldSx,
          ...(showCheckBox
            ? selectedItems.map((item) => getChipStyles(item))
            : null),
          '& .MuiInputBase-input': {
            cursor: isDiyOrLimit
              ? 'not-allowed !important'
              : 'default !important'
          }
        }}
        InputLabelProps={{
          shrink:
            !!applyFilterValues[labelText] &&
            applyFilterValues[labelText]?.length > 0
        }}
        InputProps={{
          startAdornment:
            (showCheckBox && applyFilterValues[labelText]?.length > 0) ||
            (showColorBox && applyFilterValues[labelText]) ? (
              <>
                {showCheckBox &&
                  selectedItems?.length > 0 &&
                  selectedItems.map((item, index) => (
                    <InputAdornment key={index} position="start">
                      <span style={getChipStyles(item)}>
                        {/* {item?.charAt(0)?.join(' ')} */} {item?.charAt(0)}
                      </span>
                    </InputAdornment>
                  ))}
                {showColorBox && selectedValue && selectedValue?.length && (
                  <Box
                    sx={{
                      ...CustomPopoverCss?.colorBox,
                      backgroundColor: selectedValue
                        ? colorPalette[
                            options.indexOf(applyFilterValues?.['KD %'])
                          ]
                        : 'transparent' // Set background color based on selected value
                    }}
                  />
                )}
              </>
            ) : null,
          sx: {
            '& fieldset': {
              borderColor:
                (selectedValue && !open) ||
                (!open && selectedItems?.length > 0) ||
                (filterCount > 0 && moreFilters)
                  ? 'var(--color-purple-deep-alt)'
                  : 'var(--color-text-tertiary)'
            },
            ...CustomPopoverCss?.mainTextFieldInputProp,
            ...CustomPopoverCss?.input,
            paddingLeft:
              showColorBox || selectedItems?.length > 0 ? '10px' : '0px',
            cursor: isDiyOrLimit
              ? 'not-allowed !important'
              : 'default !important'
          },
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              {!isDiyOrLimit && (
                <Box sx={CustomPopoverCss?.endAdornmentBox}>
                  {filterCount > 0 && moreFilters && (
                    <Box sx={CustomPopoverCss?.filterCountBox}>
                      <Typography sx={CustomPopoverCss?.filterCountText}>
                        {filterCount}
                      </Typography>
                    </Box>
                  )}

                  {applyFilterValues[labelText] &&
                    !open &&
                    !open &&
                    applyFilterValues[labelText]?.length > 0 && (
                      <Divider
                        sx={CustomPopoverCss?.divider}
                        orientation="vertical"
                      />
                    )}
                  {(selectedValue && !open && applyFilterValues[labelText]) ||
                  (!open &&
                    selectedItems?.length > 0 &&
                    applyFilterValues[labelText]?.length > 0) ? (
                    <ClearIcon
                      onClick={handleCancel}
                      style={CustomPopoverCss?.clearIcon}
                    />
                  ) : open ? (
                    <KeyboardArrowUpIcon sx={CustomPopoverCss?.arrowIconSx} />
                  ) : (
                    <KeyboardArrowDownIcon sx={CustomPopoverCss?.arrowIconSx} />
                  )}
                </Box>
              )}
            </InputAdornment>
          )
        }}
      />
      <Popover
        id="simple-popover"
        open={open && !isDiyOrLimit}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        disableScrollLock={true}
      >
        {moreFilters ? (
          <Box>
            <Box sx={CustomPopoverCss?.moreFilterMainTextFieldBox}>
              <Box sx={CustomPopoverCss?.keywordGoldenRatioMainBox}>
                <Typography sx={CustomPopoverCss?.keywordGoldenRatioText}>
                  {customPopoverTexts?.wordCount}
                </Typography>
                <Box sx={CustomPopoverCss?.keywordGoldenRatioTextFieldBox}>
                  <TextField
                    label="From"
                    type="text"
                    value={fromWcValue || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      const sanitizedValue = value.replace(
                        addSiteInDashboardText?.filterFieldRegex,
                        ''
                      ); // Only allow numbers
                      setFromWcValue(sanitizedValue);
                    }}
                    fullWidth
                    inputProps={{
                      style: {
                        MozAppearance: 'textfield',
                        WebkitAppearance: 'none'
                      },
                      autoComplete: 'off',
                      maxLength: 50 // Add maxLength to limit input to 50 characters
                    }}
                    InputProps={{
                      style:
                        CustomPopoverCss?.keywordGoldenRatioTextFieldInputProps
                    }}
                    sx={{
                      ...keywordResearchDashBoardCss?.removeBorderEffectForTextField,
                      ...CustomPopoverCss?.mainTextFieldSx,
                      ...keywordResearchDashBoardCss?.hideArrowForTextFields
                    }}
                  />
                  <TextField
                    label="To"
                    type="text"
                    value={toWcValue || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      const sanitizedValue = value.replace(
                        addSiteInDashboardText?.filterFieldRegex,
                        ''
                      ); // Only allow numbers
                      setToWcValue(sanitizedValue);
                    }}
                    fullWidth
                    inputProps={{
                      min: fromValue,
                      step: 'any',
                      style: {
                        MozAppearance: 'textfield',
                        WebkitAppearance: 'none'
                      },

                      autoComplete: 'off',
                      maxLength: 50 // Add maxLength to limit input to 50 characters
                    }}
                    InputProps={{
                      style:
                        CustomPopoverCss?.keywordGoldenRatioTextFieldInputProps
                    }}
                    sx={{
                      ...keywordResearchDashBoardCss?.removeBorderEffectForTextField,
                      ...CustomPopoverCss?.mainTextFieldSx,
                      ...keywordResearchDashBoardCss?.hideArrowForTextFields
                    }}
                  />
                </Box>
              </Box>
            </Box>
            {error && (
              <Box sx={CustomPopoverCss?.alert}>
                <Alert severity="error">{customPopoverTexts?.errorText}</Alert>
              </Box>
            )}
            <Box sx={CustomPopoverCss?.moreFilterBtnBox}>
              <Button
                variant="outlined"
                sx={CustomPopoverCss?.applyBtn}
                color="primary"
                onClick={handleClearFilters}
              >
                {customPopoverTexts?.clearFilters}
              </Button>
              <Button
                variant="contained"
                sx={CustomPopoverCss?.applyBtn}
                disabled={
                  (!toKrValue?.trim() || !fromKrValue?.trim()) &&
                  (!toWcValue?.trim() || !fromWcValue?.trim())
                }
                color="primary"
                // onClick={handleApply}
                onClick={handleVerify}
              >
                {customPopoverTexts?.apply}
              </Button>
            </Box>
          </Box>
        ) : (
          <Box>
            <List sx={CustomPopoverCss?.list}>
              {options.map((option, index) => (
                <ListItem
                  sx={{
                    padding: showCheckBox ? '' : '10px',
                    backgroundColor:
                      selectedItems.indexOf(option) !== -1 ||
                      selectedValue == option
                        ? 'rgba(231, 223, 255, 1)'
                        : '',
                    '&:hover': {
                      backgroundColor: 'rgba(231, 223, 255, 1)'
                    }
                  }}
                  key={index}
                  button
                  onClick={() => handleSelect(option)}
                  dense
                >
                  {showCheckBox && (
                    <Checkbox
                      edge="start"
                      onClick={(event) => event.stopPropagation()} // Prevents listItem onClick when checkbox is clicked
                      onChange={() => handleSelect(option)}
                      checked={selectedItems.indexOf(option) !== -1}
                      tabIndex={-1}
                      disableRipple // Optional to improve UI interaction
                    />
                  )}
                  {showColorBox && (
                    <Box sx={CustomPopoverCss?.showColorBox}>
                      <Box
                        sx={{
                          ...CustomPopoverCss?.colorOption,
                          backgroundColor: colorPalette[index]
                        }}
                      />
                      <Box>
                        <Typography sx={CustomPopoverCss?.option}>
                          {option}
                        </Typography>
                        <Typography
                          sx={CustomPopoverCss?.keywordResearchKdSubOptions}
                        >
                          {keywordResearchKdSubOptions[index]}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  {!showColorBox && (
                    <Typography sx={CustomPopoverCss?.option}>
                      {option}
                    </Typography>
                  )}
                </ListItem>
              ))}
              {showFields && (
                <Box>
                  <Divider
                    sx={CustomPopoverCss?.dividerHorizontal}
                    component="li"
                  />
                  <Typography sx={CustomPopoverCss?.customRange}>
                    {customPopoverTexts?.customRange}
                  </Typography>
                  <ListItem sx={CustomPopoverCss?.listItemShowFields}>
                    <TextField
                      label="From"
                      type="text"
                      value={fromValue || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        const sanitizedValue = value.replace(
                          addSiteInDashboardText?.filterFieldRegex,
                          ''
                        ); // Only allow numbers
                        setFromValue(sanitizedValue);
                      }}
                      fullWidth
                      inputProps={{
                        style: {
                          MozAppearance: 'textfield',
                          WebkitAppearance: 'none'
                        },
                        autoComplete: 'off',
                        maxLength: 50 // Add maxLength to limit input to 50 characters
                      }}
                      InputProps={{
                        style:
                          CustomPopoverCss?.keywordGoldenRatioTextFieldInputProps
                      }}
                      sx={{
                        ...keywordResearchDashBoardCss?.removeBorderEffectForTextField,
                        ...CustomPopoverCss?.mainTextFieldSx,
                        ...keywordResearchDashBoardCss?.hideArrowForTextFields
                      }}
                    />
                    <TextField
                      label="To"
                      type="text"
                      value={toValue || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        const sanitizedValue = value.replace(
                          addSiteInDashboardText?.filterFieldRegex,
                          ''
                        ); // Only allow numbers
                        setToValue(sanitizedValue);
                      }}
                      fullWidth
                      inputProps={{
                        min: fromValue,
                        step: 'any',
                        style: {
                          MozAppearance: 'textfield',
                          WebkitAppearance: 'none'
                        },

                        autoComplete: 'off',
                        maxLength: 50 // Add maxLength to limit input to 50 characters
                      }}
                      InputProps={{
                        style:
                          CustomPopoverCss?.keywordGoldenRatioTextFieldInputProps
                      }}
                      sx={{
                        ...keywordResearchDashBoardCss?.removeBorderEffectForTextField,
                        ...CustomPopoverCss?.mainTextFieldSx,
                        ...keywordResearchDashBoardCss?.hideArrowForTextFields
                      }}
                    />
                  </ListItem>
                </Box>
              )}
              {error && (
                <ListItem sx={CustomPopoverCss?.alert}>
                  <Alert severity="error">
                    {customPopoverTexts?.errorText}
                  </Alert>
                </ListItem>
              )}
              <ListItem>
                <Button
                  variant="contained"
                  sx={CustomPopoverCss?.applyBtn}
                  color="primary"
                  // onClick={handleApply}
                  onClick={handleVerify}
                  disabled={
                    (!showCheckBox &&
                      !selectedValue?.trim() &&
                      !fromValue?.trim() &&
                      !toValue?.trim()) ||
                    (showCheckBox && selectedItems?.length == 0)
                  }
                >
                  {customPopoverTexts?.apply}
                </Button>
              </ListItem>
            </List>
          </Box>
        )}
      </Popover>
    </Box>
  );
};
